import { UsuariosService } from 'src/app/services/usuarios/usuarios.service';
import { PerfilamientoService } from './../../services/perfilamiento/perfilamiento.service';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { customEnv } from 'src/environments/customEnv';
@Component({
  selector: 'app-view-pagina-sin-acceso',
  templateUrl: './view-pagina-sin-acceso.component.html',
  styleUrls: ['./view-pagina-sin-acceso.component.scss']
})
export class ViewPaginaSinAccesoComponent {
  correoSoporte: string = customEnv.correoSoporte
  showLogoutBtn: boolean = false

  constructor(
    private router: Router,
    private _perfilamiento: PerfilamientoService,
    private _usuarios: UsuariosService
  ) { }

  toggleLogoutBtn() {
    this.showLogoutBtn = !this.showLogoutBtn
  }
  irAlLogin() {
    this.toggleLogoutBtn()
    this._perfilamiento.deleteUsuario()
    this._perfilamiento.asyncUserData(null)
    this._perfilamiento.deleteMenu()
    this._perfilamiento.asyncMenuData(null)
    this._usuarios.removeToken()
    if ( environment.devLocal ) {
      this.router.navigate(['/login'])
    } else {
      window.location.href = environment.logoutUrl
    }
  }
}
